import { render, staticRenderFns } from "./rm-header-mobile.vue?vue&type=template&id=2b323173&"
import script from "./rm-header-mobile.vue?vue&type=script&lang=js&"
export * from "./rm-header-mobile.vue?vue&type=script&lang=js&"
import style0 from "./rm-header-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports